import { createAction, createReducer } from '@reduxjs/toolkit';

const START = createAction('network/start');
const END = createAction('network/end');

export const actions = {
  START,
  END,
};

function startHandler(prev) {
  return ++prev;
}

function endRequest(prev) {
  return Math.max(0, --prev);
}

const reducer = createReducer(0, {
  [START]: startHandler,
  [END]: endRequest,
});

export default reducer;
